/// <reference types="vite-svg-loader" />
// eslint-disable-next-line import-x/no-unresolved -- virtual module provided by iconGroupPlugin in vite.config
import groupLoaders from "virtual:icon-groups";
import type { Component } from "vue";
import { defineAsyncComponent } from "vue";

import { captureException } from "@/error/sentry";
import PlaceholderIcon from "@/icons/system/placeholder.svg?component";
import type { Icon } from "@/model/icon";

import SvgLoadingPlaceholder from "../SvgLoadingPlaceholder.vue";

export function getIconComponent(fullName: Icon) {
  const pos = fullName.indexOf("/");
  const group = fullName.slice(0, pos);
  const name = fullName.slice(pos + 1);
  return defineAsyncComponent({
    loader: async () => {
      try {
        const icons = await loadGroup(group);
        return icons[name] ?? PlaceholderIcon;
      } catch (err) {
        captureException(err);
        return PlaceholderIcon;
      }
    },
    loadingComponent: SvgLoadingPlaceholder,
    delay: 0,
  });
}

const groupCache = new Map<string, Promise<Record<string, Component>>>();

function loadGroup(groupName: string): Promise<Record<string, Component>> {
  let group = groupCache.get(groupName);
  if (!group) {
    group =
      groupLoaders[groupName]?.() ?? Promise.reject(new Error(`Unknown icon group: ${groupName}`));
    group.catch(() => groupCache.delete(groupName));
    groupCache.set(groupName, group);
  }
  return group;
}
